import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
// User Profile DTO
export const UserProfileSchema = z.object({
    id: z.string(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    locale: z.string().optional(),
    createdAt: z.string().datetime().optional(),
    email: z.string().email().nullable().optional(),
    type: z.enum(['ditto', 'client', 'consultant']).optional(),
    consultantOrganizationId: z.string().nullable().optional(),
    consultantOrganizationName: z.string().nullable().optional(),
});
// Update User Profile DTO
export const UpdateUserProfileSchema = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    locale: z.string().optional(),
});
// API Error Schema
export const ApiErrorSchema = z.object({
    message: z.string(),
    statusCode: z.number(),
});
export const userContract = c.router({
    getUserProfile: {
        method: 'GET',
        path: '/user/profile',
        summary: 'Get current user profile',
        responses: {
            200: UserProfileSchema,
            401: ApiErrorSchema,
            404: ApiErrorSchema,
        },
    },
    getUsers: {
        method: 'GET',
        path: '/users',
        summary: 'Get all users',
        responses: {
            200: z.array(UserProfileSchema),
        },
    },
    getUserById: {
        method: 'GET',
        path: '/users/:id',
        summary: 'Get user by ID',
        responses: {
            200: UserProfileSchema,
            401: ApiErrorSchema,
            404: ApiErrorSchema,
        },
    },
    updateUserProfile: {
        method: 'PUT',
        path: '/user/profile',
        summary: 'Update current user profile',
        body: UpdateUserProfileSchema,
        responses: {
            200: UserProfileSchema,
            400: ApiErrorSchema,
            401: ApiErrorSchema,
            404: ApiErrorSchema,
        },
    },
    getKnockToken: {
        method: 'GET',
        path: '/user/me/knock-token',
        summary: 'Get Knock token for the current user',
        responses: {
            200: z.object({
                userId: z.string(),
                token: z.string(),
            }),
        },
    },
});
//# sourceMappingURL=user.js.map